import React from "react";
import { CommunityProps, CommunityUserFeed } from "../../types";
const LazyDiscussList = React.lazy(() => import("../discuss/discussList"));
const LazyUserFeedList = React.lazy(() => import("../userFeed/userFeedList"));

type ComUserFeedProps = {
  comUserFeed: CommunityUserFeed;
  refetch: () => void;
  isRefetching: () => void;
  community?: CommunityProps;
  isFetchingComFeeds: () => void;
  index: any;
  comfeedId: any;
  isLoading: boolean;
  loadData: boolean;
};
const ComUserFeed: React.FC<ComUserFeedProps> = ({
  comUserFeed,
  refetch,
  isRefetching,
  community,
  isFetchingComFeeds,
  loadData,
  index,
  comfeedId,
  isLoading,
}) => {
  const _type = "UserFeedCommunity";

  return (
    <div className="w-full" key={comUserFeed?.id}>
      {comUserFeed?.community && comUserFeed?.community?.name ? (
        <LazyDiscussList
          communityFeed={comUserFeed}
          refetch={isFetchingComFeeds}
          community={community}
          isRefetching={isRefetching}
          loadData={loadData}
          index={index}
          Type={_type}
        />
      ) : (
        <LazyUserFeedList
          userFeed={comUserFeed}
          refetch={refetch}
          isLoading={isLoading}
        />
      )}
    </div>
  );
};

export default ComUserFeed;
